export default "__VITE_ASSET__BUZdkQQ___"